// Packages
import React, { useEffect } from "react"
import PropTypes from "prop-types"

// Styles
import "./PromoContent.scss"

function PromoContent({ promoHTML }) {
  useEffect(() => {
    window.CarouselWrapper()
  }, [])

  return (
    <div
      className="PromoContent"
      dangerouslySetInnerHTML={{ __html: promoHTML }}
    />
  )
}

PromoContent.propTypes = {
  promoHTML: PropTypes.string,
}

export default PromoContent
